import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { login } from '../../utility/account.js';
import { addMessage } from '../../actions/messages.js';

/**
 * Component for showing login form.
 *
 * @extends React.Component
 */
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
    }
  }

  /**
   * Handle submission of login form.
   *
   * @param {object} e - The event object.
   */
  login = (e) => {
    e.preventDefault();
    var ctx = this;
    login(this.state.email, this.state.password, this.props.history, this.props.dispatch, (success, response) => {
      if (success) {
        ctx.props.history.push('/');
      } else if (response.status === 401) {
        ctx.props.dispatch(addMessage('Forkerte logininformationer. Prøv venligst igen', 'warning'));
      } else {
        ctx.props.dispatch(addMessage('Fejl under login, prøv igen senere.', 'danger'));
      }
    });
  }

  /**
   * Handle change in email field.
   *
   * @param {object} e - The event object.
   */
  handleEmailChange = (e) => {
    this.setState({email: e.target.value});
  }

  /**
   * Handle change in password field.
   *
   * @param {object} e - The event object.
   */
  handlePasswordChange = (e) => {
    this.setState({password: e.target.value});
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="col-sm-8 offset-sm-2">
        <div className="widget">
          <div className="container">
            <h1>Log ind</h1>
            <form onSubmit={this.login}>
              <div className="form-group">
                <label htmlFor="email">E-mailadresse</label>
                <input type="email" id="email" className="form-control" placeholder="Angiv e-mailadresse" value={this.state.email} onChange={this.handleEmailChange} />
              </div>
              <div className="form-group">
                <label htmlFor="password">Adgangskode</label>
                <input type="password" id="password" className="form-control" placeholder="Adgangskode" value={this.state.password} onChange={this.handlePasswordChange} />
              </div>
              <input type="submit" className="btn btn-primary" value="Log ind" />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(LoginForm));



// WEBPACK FOOTER //
// ./src/components/LoginForm/index.js